import React from "react";
import mockImg from "/mockimg2.png";
const BrandPhilosophy = () => {
  return (
    <section className="py-20 bg-cloud-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            {/* Text Content */}
            <div className="space-y-6">
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-forest-green mb-8">
                About Cittasya®
              </h2>

              <div className="space-y-6 text-lg leading-relaxed text-copper-brown">
                <p>
                  Our mission is to make the transformative power of yogic
                  practices accessible to everyone and help people reconnect
                  with their inner wisdom.
                </p>

                <p>
                  Cittasya® is a wellness brand dedicated to the healing power
                  of conscious relaxation through the art and science of Yoga
                  Nidra.
                </p>

                <p>
                  <div>
                    <p>
                      <p>
                        In a world that prizes productivity over peace, we offer an
                  intentional pause. Cittasya® blends ancient wisdom
                  with modern neuroscience to deliver accessible, inclusive, and
                  deeply nourishing practices. Whether you’re navigating stress,
                  seeking emotional healing or simply craving stillness in a
                  noisy world, our offerings support your journey inward, where
                  true rest and renewal begin. At its core, the company is built
                  on the belief that deep rest is not a luxury, but a necessity.
                      </p>
                    </p>
                  </div>
                </p>
                <p>
                  The company offers guided lying-down sessions to soothe the
                  nervous system, enhance clarity, restore balance, and improve
                  sleep. Cittasya® is your personal companion for conscious rest
                  and reinvigoration day after day.{" "}
                </p>
              </div>

              {/* Quote Block */}
              {/* <div className="bg-misty-sage/50 p-8 rounded-lg border-l-4 border-soft-saffron mt-8">
                <p className="text-forest-green font-medium italic text-xl">
                  "Rest is not a luxury — it's a gateway to healing, balance, and purpose."
                </p>
              </div> */}
            </div>

            {/* Visual Element */}
            <div className="relative">
              <img src={mockImg} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandPhilosophy;
